import * as t from "io-ts";
import { ScanType } from "./ScanType";

export const ScanningLocation = t.type({
  id: t.union([t.string, t.number]),
  slug: t.string,
  name: t.string,
  about: t.union([t.null, t.string]),
  latitude: t.number,
  longitude: t.number,
  address: t.string,
  town: t.union([t.null, t.string]),
  county: t.union([t.null, t.string]),
  distance: t.union([t.null, t.number]),
  scan_types: t.array(ScanType),
  from_price: t.union([t.null, t.number]),
  thumbnail_image: t.union([t.null, t.string]),
  rating: t.number,
  review_count: t.number,
});

export type ScanningLocation = t.TypeOf<typeof ScanningLocation>;

export const ScanningLocationResponse = t.type({
  locations: t.array(ScanningLocation),
});

export type ScanningLocationResponse = t.TypeOf<
  typeof ScanningLocationResponse
>;
